<template>
  <v-app>
    <v-content v-if="!isKeToan">

      <!-- <v-btn color="primary" fab small dark @click="drawer = !drawer" class="show-draw">
        <v-icon>list</v-icon>
      </v-btn> -->

      <router-view></router-view>

      <!-- <v-speed-dial
        v-if="!showDraw"
        top
        left
        direction="top"
        open-on-hover
        transition="fade-transition"
      >
        
      </v-speed-dial> -->

      <!-- <v-btn color="primary" fab small dark @click="drawer = !drawer" class="show-draw">
        <v-icon>list</v-icon>
      </v-btn> -->

    </v-content>

    <v-content v-else>
  
      <router-view></router-view>

    </v-content>
  </v-app>
</template>
<script>
  import $ from 'jquery'
  import router from '@/router'
  // import axios from 'axios'
  export default {
    data: () => ({
      fab: false,
      tinMois: [],
      initData: null,
      isKeToan: false,
      showDraw: false
    }),
    computed: {
      drawer: {
        get () {
          return this.$store.getters.drawer
        },
        set (val) {
          this.$store.commit('setDrawer', val)
        }
      }
    },
    created () {
      var vm = this
      // var dataPost = new URLSearchParams()
      // dataPost.append('payload', JSON.stringify([{ccc: 'cccc'}]))
      // axios.post('/ccccc', dataPost, {
      //   headers: {
      //     groupId: 55217
      //   }
      // })
      vm.$nextTick(function () {
      })
    },
    watch: {
      // 'drawer': function (val) {
      //   console.log('drawer+++++++++++', this.drawer)
      //   this.showDraw = this.drawer
      // },
      '$route': function (newRoute, oldRoute) {
        let vm = this
        let newtype = newRoute.params.type
        console.log('newtype', newtype)
        if (vm.initData !== null && vm.initData !== undefined && vm.initData !== 'undefined') {
          // vm.$store.dispatch('getTinMois').then(function (result) {
          //   if (result !== null && result !== undefined && result !== 'undefined') {
          //     vm.tinMois = result
          //   } else {
          //     vm.tinMois = []
          //   }
          // })
        }
      }
    },
    destroyed () {
      $('#navigation>ul>li.extend').remove()
    },
    methods: {
      toDetailNoti (item, isKeHoach) {
        if (isKeHoach) {
          router.push('/ho-so/ke_hoach/' + item.documentName + '/' + item.documentYear + '/' + item.documentTypeCode + '/' + item.documentRequestState)
        } else {
          router.push('/ho-so/thu_tuc/' + item.documentName + '/' + item.documentYear + '/' + item.documentTypeCode + '/' + item.documentStatusCode)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?3f4cedf4